<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    export let fill = $theme.colors.white;
    // width="20" height="21"
</script>

<svg {...$$restProps} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1863_19495)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.6925 9.64643V9.62207C10.6875 9.63024 10.6806 9.63841 10.6763 9.64643H10.6925Z"
            {fill}
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.66675 2.16113V18.8278H18.3334V2.16113H1.66675ZM6.8507 16.0074H4.37796V8.56795H6.8507V16.0074ZM5.61433 7.55256H5.59799C4.76851 7.55256 4.23085 6.9811 4.23085 6.26681C4.23085 5.53685 4.78422 4.98157 5.63052 4.98157C6.477 4.98157 6.99719 5.53685 7.01338 6.26681C7.01338 6.9811 6.477 7.55256 5.61433 7.55256ZM15.7693 16.0074H13.2959V12.0272C13.2959 11.0276 12.9385 10.3452 12.0433 10.3452C11.3597 10.3452 10.9534 10.8046 10.7744 11.2497C10.7094 11.4087 10.6924 11.6297 10.6924 11.8526V16.0074H8.21851C8.21851 16.0074 8.25166 9.26589 8.21851 8.56798H10.6924V9.62216C11.0211 9.11641 11.6076 8.39333 12.9215 8.39333C14.5493 8.39333 15.7693 9.45633 15.7693 11.7412V16.0074Z"
            {fill}
        />
    </g>
    <defs>
        <clipPath id="clip0_1863_19495">
            <rect x="1.66675" y="2.16113" width="16.6667" height="16.6667" rx="2" {fill} />
        </clipPath>
    </defs>
</svg>
